import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const ArtContainer = styled.div`
  min-height: 100vh;
  // background: #f8f8f8;
  // padding: 4rem 2rem;
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
  padding: 2rem 0.5rem; /* reduce horizontal padding on small screens */

`;

export const ArtGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 3rem;
  padding: 2rem;
  max-width: 1800px;
  margin: 0 auto;
  overflow-x: hidden;

  a {
    display: block;
    height: 100%;
    cursor: pointer;
  }
`;

export const ArtCard = styled.div`
  position: relative;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.4s ease;
  animation: ${fadeIn} 0.6s ease forwards;
  animation-delay: ${props => props.index * 0.1}s;
  opacity: 0;
  height: 100%;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);

    .art-overlay {
      opacity: 1;
    }

    img {
      transform: scale(1.1);
    }
  }
`;

export const ArtImage = styled.img`
  width: 100%;
  height: 400px;
  object-fit: cover;
  transition: transform 0.4s ease;
`;

export const ArtOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.4s ease;
  padding: 2rem;
  text-align: center;
  backdrop-filter: blur(5px);
`;

export const ArtTitle = styled.h2`
  color: white;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 500;
  transform: translateY(20px);
  transition: transform 0.4s ease;

  ${ArtCard}:hover & {
    transform: translateY(0);
  }
`;

export const ArtDescription = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 1rem;
  line-height: 1.6;
  transform: translateY(20px);
  transition: transform 0.4s ease;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  ${ArtCard}:hover & {
    transform: translateY(0);
  }
`;

export const ViewButton = styled.button`
  background: transparent;
  border: 2px solid white;
  color: white;
  padding: 0.8rem 2rem;
  margin-top: 1.5rem;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  transform: translateY(20px);
  opacity: 0;

  ${ArtCard}:hover & {
    transform: translateY(0);
    opacity: 1;
  }

  &:hover {
    background: white;
    color: black;
  }
`;

export const CategoryFilter = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 3rem;
  flex-wrap: wrap;
`;

export const FilterButton = styled.button`
  background: ${props => props.active ? 'black' : 'transparent'};
  color: ${props => props.active ? 'white' : 'black'};
  border: 2px solid black;
  padding: 0.8rem 2rem;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 30px;

  &:hover {
    background: black;
    color: white;
  }
`; 